/**
 * Whether GET /manifest/current/ should run.
 *
 * Pre-auth pages without /o/<slug>/ or a session must not call manifest - * resolveRequestTenantSlug would fall back to env default (e.g. "tnn") and
 * staging returns slug_unknown.
 */
export function shouldFetchManifest(options: {
  urlTenantSlug: string | null;
  isAuthenticated: boolean;
}): boolean {
  if (options.isAuthenticated) return true;
  return Boolean(options.urlTenantSlug?.trim());
}
